import Request from './request.js'
export default class {
  /**
   * 提示框
   * @param msg 要提示的消息
   * @returns {Promise.<void>}
   */
  async confirm (msg) {
    let cb = {isOk: true}
    this.$emit('beforeExport', cb)
    if (!cb.isOk) return
    if (this.type) return this.type
    let type = ''
    const h = this.$createElement
    await new Promise(resolve => {
      this.$confirm(msg, '请选择导出方式', {
        confirmButtonText: '导出搜索结果',
        confirmButtonClass: 'component-export-confirmButtonClass',
        customClass: 'component-export',
        type: 'warning',
        showCancelButton: false,
        message: h('el-button', {
          class: 'component-export-cancelButtonClass',
          props: {
            type: 'primary',
            size: 'small'
          },
          on: {
            click () {
              type = 'current'
              $('.component-export').find('.el-message-box__close.el-icon-close').trigger('click')
              resolve()
            }
          }
        }, ['导出当前页'])
      }).then(() => {
        type = 'all'
        resolve()
      }).catch(() => {
        // cancel
      })
    })
    return type
  }
  async exportExcel (dataOutType) {
    let success = await Request.exportExcel.call(this, {dataOutType, search: this.search})
    if (success) {
      window.utils.flyAnimate({
        menuName: '导出历史',
        startFunction: this.$message.success.bind(this, '已申请导出')
      })
    } else {
      this.$message.error(this, '申请导出失败')
    }
  }
}
